module.exports = __webpack_public_path__ + "img/logo-primary.a6bee017.png";